<template>
  <!-- 徽章主页入口 -->
  <div class="container">
    <div class="header">
      <navBar></navBar>
    </div>
    <div class="main-wrapper">
      <!-- 左侧菜单卡片 -->
      <div class="sidebar-card">
        <div class="sidebar-title">徽章管理</div>
        <el-menu
          class="sidebar-menu"
          router
          :default-active="$route.path"
          mode="vertical"
        >
          <myitem :data="routerData"></myitem>
        </el-menu>
      </div>
      <!-- 主内容区 -->
      <div class="main-content">
        <router-view :key="$route.path"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import myitem from "./menuItem/index.vue";
import routerList from "@/router/medal/pc";
import navBar from "./headerLogo/index.vue";
import api from "@/apis/medal";

export default {
  name: "gzhpc",
  components: {
    myitem,
    navBar
  },
  data() {
    return {
      routerData: []
    };
  },
  computed: {
    routes() {
      return routerList;
    }
  },
  created() {
    this.queryData();
  },
  methods: {
    async queryData() {
      try {
        const res = await api.queryMedalUserPermission({
          name: this.$store.state.userInfo.username
        });
        if (res.code === 200) {
          // 修复递归过滤逻辑，传入权限列表
          this.routerData = this.filterData(routerList[0]?.children || [], res.data.list);
        }
      } catch (error) {
        console.error("获取菜单权限失败：", error);
      }
    },
    /**
     * 递归过滤菜单权限
     * @param {Array} data 路由菜单
     * @param {Array} permissions 权限列表
     * @returns 过滤后的菜单
     */
    filterData(data = [], permissions = []) {
      if (!data.length) return [];
      
      return data.filter(item => {
        // 徽章管理权限判断
        if (item.path === "/medal/badgeManage") {
          const admin = permissions[0]?.administrators;
          const record = permissions[0]?.medalRecord;
          item.show = admin || record;
        } else {
          item.show = true;
        }

        // 递归处理子菜单
        if (item.children?.length) {
          item.children = this.filterData(item.children, permissions);
        }
        return item.show;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
/* 整体布局 - 清爽无边框、现代感 */
.container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f5f7f9;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

/* 顶部导航 */
.header {
  height: 112px;
  padding: 0;
  background-color: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  z-index: 10;
}

/* 主体布局 */
.main-wrapper {
  flex: 1;
  display: flex;
  overflow: hidden;
  padding: 20px;
  gap: 20px;
}

/* 左侧菜单容器 - 高级质感 */
.sidebar-card {
  width: 350px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* 左侧标题 */
.sidebar-title {
  padding: 32px 24px;
  font-size: 32px;
  font-weight: 600;
  color: #1f2937;
  text-align: center;
  border-bottom: 1px solid #f0f2f5;
}

/* 菜单主体 - 主色调：墨绿色系（专业、清爽） */
.sidebar-menu {
  flex: 1;
  border: none;
  background-color: #ffffff;
  overflow-y: auto;
  padding: 12px 0;

  /* 隐藏滚动条 */
  &::-webkit-scrollbar {
    display: none;
  }

  /* 菜单项基础样式 */
  :deep(.el-menu-item) {
    height: 70px !important;
    line-height: 70px !important;
    font-size: 28px;
    color: #4b5563;
    padding: 0 28px !important;
    transition: all 0.25s ease;
    border-radius: 8px;
    margin: 4px 16px;
  }

  /* 菜单悬浮 */
  :deep(.el-menu-item:hover) {
    background-color: #e6f4ef !important;
    color: #008754 !important;
  }

  /* 菜单选中 */
  :deep(.el-menu-item.is-active) {
    background-color: #008754 !important;
    color: #ffffff !important;
    font-weight: 500;
  }

  /* 子菜单标题 */
  :deep(.el-submenu__title) {
    height: 70px !important;
    line-height: 70px !important;
    font-size: 28px;
    color: #4b5563;
    padding: 0 28px !important;
    margin: 4px 16px;
    border-radius: 8px;
  }

  /* 文字自动换行 */
  span {
    white-space: normal;
    word-break: break-all;
    line-height: 36px;
  }
}

/* 右侧主内容区 */
.main-content {
  flex: 1;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 24px;
  overflow-y: auto;
}
</style>